import React from "react";
import { Outlet, useOutletContext, useParams } from "react-router-dom";
import FormsLoading from "../../Loaders/components/Form";
import { useGetSessionInfoQuery } from "../../../services/submissionPeriod/api";
import { SESSION_KINDS } from "../../../util/constants";

function FormRouteIndex() {
  const { type } = useParams();
  const outletContext = useOutletContext();
  useGetSessionInfoQuery({ type: SESSION_KINDS.FGC });
  
  if (!type) {
    return <div>List form types here</div>;
  }

  return (
    <React.Suspense fallback={<FormsLoading />}>
      <Outlet context={outletContext} />
    </React.Suspense>
  );
}

export default FormRouteIndex;
